export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-xs">
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-base text-background-50">
                <i className="ri-water-flash-line"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                吃瓜入口
              </span>
            </a>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              常回来看看就不会走丢。新入口永久有效，换址信息实时更新，愿每一次进来都吃瓜愉快。
            </p>
          </div>

          <div className="flex flex-wrap gap-10">
            <div>
              <h4 className="text-sm font-semibold text-foreground-950">快速浏览</h4>
              <ul className="mt-3 flex flex-col gap-2 text-sm text-foreground-600">
                <li><a href="#hot" className="hover:text-foreground-950">今日热瓜</a></li>
                <li><a href="#boards" className="hover:text-foreground-950">社区板块</a></li>
                <li><a href="#discuss" className="hover:text-foreground-950">正在聊</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-950">入口帮助</h4>
              <ul className="mt-3 flex flex-col gap-2 text-sm text-foreground-600">
                <li><a href="#guide" className="hover:text-foreground-950">收藏本站</a></li>
                <li><a href="#guide" className="hover:text-foreground-950">备用入口</a></li>
                <li><a href="#guide" className="hover:text-foreground-950">常见问题</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-950">关注公告</h4>
              <p className="mt-3 flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-radio-button-line text-accent-500"></i>
                换址信息实时更新
              </p>
              <p className="mt-2 flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-chat-smile-3-line text-secondary-600"></i>
                讨论区友好交流
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 text-center text-xs text-foreground-500 sm:flex-row sm:text-left">
          <p>© 吃瓜入口 · 页面仅供信息展示与娱乐讨论，交流请理性友善。</p>
          <div className="flex items-center gap-2 whitespace-nowrap">
            <i className="ri-shield-check-line"></i>
            备用通道持续维护中
          </div>
        </div>
      </div>
    </footer>
  );
}